// @need-translate
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {AppLinkFallbackType} from '../../../applink/AppLinkFallbackType.enum';
import {pagewebUrlMatcher} from '../../../applink/PagewebUrlMatcher.singleton';
import {UrlLink} from '../../../applink/UrlLink';
import {requestContext} from '../../../common/requestContext';
import {Text} from '../../../design-system/atoms/Text/Text';
import {AppDownload} from '../../../design-system/organisms/AppDownload/AppDownload';
import {PcSearchesToolbar} from '../../../design-system/organisms/PcSearchesToolbar/PcSearchesToolbar';
import {PopularSearches} from '../../../design-system/organisms/PopularSearches/PopularSearches';
import {PopularSearchesItem} from '../../../design-system/organisms/PopularSearchesItem/PopularSearchesItem';
import {SearchMainQuery} from '../../../graphql/generated/types';
import {addRecentKeyword} from '../../../recentSearchKeyword/recentKeywordList.storage';
import {setOpenPcSearchModal} from '../state/searchSlice';

interface SearchMainContainerProps {
  data: SearchMainQuery;
}

export function SearchMainContainer({
  data: searchMainQuery,
}: SearchMainContainerProps) {
  const dispatch = useDispatch();
  const data = {
    keywordRankList: searchMainQuery.searchMain?.keywordRankList,
  };

  const isMobile = requestContext.requestInfo.display.isMobile;

  const onClickPcSearchClose = useCallback(() => {
    dispatch(setOpenPcSearchModal(false));
  }, [dispatch]);

  const onClickPopularItem = useCallback((keyword: string) => {
    addRecentKeyword(keyword);
  }, []);

  return (
    <>
      {isMobile && (
        <>
          {data?.keywordRankList && data?.keywordRankList.length > 0 && (
            <PopularSearches className="mx-15pxr py-24pxr">
              {data?.keywordRankList.map((item, index) => (
                <UrlLink
                  key={item.keyword}
                  url={item.url}
                  linkClassName="w-1/2 h-24pxr shrink-0"
                >
                  <PopularSearchesItem
                    index={index}
                    rank={item.rank}
                    keyword={item.keyword}
                    isMobile={isMobile}
                    onClickItem={onClickPopularItem}
                  />
                </UrlLink>
              ))}
            </PopularSearches>
          )}
          <AppDownload
            isMobile={true}
            onClickAppLink={() =>
              window.location.assign(
                pagewebUrlMatcher.getCurrentAppLink({
                  schemePrefixType: 'applink',
                  fallbackType: AppLinkFallbackType.Store,
                })
              )
            }
          />
        </>
      )}

      {!isMobile && (
        <>
          <div className="flex flex-1 flex-col">
            {data?.keywordRankList && (
              <div className="my-8pxr flex flex-1 flex-col px-12pxr">
                {data?.keywordRankList.map((item, index) => (
                  <UrlLink key={item.keyword} url={item.url}>
                    <PopularSearchesItem
                      index={index}
                      key={item.id}
                      rank={item.rank}
                      keyword={item.keyword}
                      className="h-34pxr pl-8pxr"
                      isMobile={isMobile}
                      onClickItem={onClickPopularItem}
                    />
                  </UrlLink>
                ))}
                {data?.keywordRankList.length === 0 && (
                  <div className="flex-center-full">
                    <Text className="font-small1 w-full text-center text-theme-solid-40">
                      검색어 집계중입니다.
                    </Text>
                  </div>
                )}
              </div>
            )}
            <PcSearchesToolbar onClickClose={onClickPcSearchClose} />
          </div>
        </>
      )}
    </>
  );
}
